import { Comment } from "./comment";
import { Highlight } from "./highlight";
import { Shape } from "./shape";

export const allAnnotatorTools: any[] = [new Comment(), new Highlight(), new Shape()];